// Função para criar o id de programa a partir da descrição
export function gerarIdPrograma(descricao) {
  if (!descricao) return '';
  // Gera um slug e um hash simples
  const slug = descricao
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  // Hash simples: soma dos char codes
  const hash = Array.from(descricao).reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return `${slug}-${hash}`;
}
import React from 'react';

function ProgramaModal({ show, onClose, onSubmit, form, handleChange, title = 'CADASTRO DE PROGRAMA' }) {
  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-diagram-3 me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              {/* Campo ID removido conforme solicitado */}
              <div className="mb-3">
                <label className="form-label">Descrição *</label>
                <input type="text" className="form-control" name="descricao" value={form.descricao} onChange={handleChange} required />
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProgramaModal;
